module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: _vm.classes,
    attrs: {
      "role": "treeitem",
      "draggable": _vm.draggable
    },
    on: {
      "dragstart": function($event) {
        $event.stopPropagation();
        _vm.onItemDragStart($event, _vm._self, _vm._self.model)
      },
      "dragend": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.onItemDragEnd($event, _vm._self, _vm._self.model)
      },
      "dragover": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDragEnter = true
      },
      "dragenter": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDragEnter = true
      },
      "dragleave": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isDragEnter = false
      },
      "drop": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.handleItemDrop($event, _vm._self, _vm._self.model)
      }
    }
  }, [(_vm.isWholeRow) ? _c('div', {
    class: _vm.wholeRowClasses,
    attrs: {
      "role": "presentation"
    }
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "tree-icon tree-ocl",
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": _vm.handleItemToggle
    }
  }), _vm._v(" "), _c('div', _vm._g({
    class: _vm.anchorClasses
  }, _vm.events), [(_vm.showCheckbox && !_vm.model.loading) ? _c('i', {
    staticClass: "tree-icon tree-checkbox",
    attrs: {
      "role": "presentation"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default", [(!_vm.model.loading) ? _c('i', {
    class: _vm.themeIconClasses,
    attrs: {
      "role": "presentation"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.model[_vm.textFieldName])
    }
  })], {
    vm: this,
    model: _vm.model
  })], 2), _vm._v(" "), (_vm.isFolder) ? _c('ul', {
    ref: "group",
    staticClass: "tree-children",
    style: (_vm.groupStyle),
    attrs: {
      "role": "group"
    }
  }, _vm._l((_vm.model[_vm.childrenFieldName]), function(child, index) {
    return _c('tree-item', {
      key: index,
      attrs: {
        "data": child,
        "text-field-name": _vm.textFieldName,
        "value-field-name": _vm.valueFieldName,
        "children-field-name": _vm.childrenFieldName,
        "item-events": _vm.itemEvents,
        "whole-row": _vm.wholeRow,
        "show-checkbox": _vm.showCheckbox,
        "allow-transition": _vm.allowTransition,
        "height": _vm.height,
        "parent-item": _vm.model[_vm.childrenFieldName],
        "draggable": _vm.draggable,
        "drag-over-background-color": _vm.dragOverBackgroundColor,
        "on-item-click": _vm.onItemClick,
        "on-item-toggle": _vm.onItemToggle,
        "on-item-drag-start": _vm.onItemDragStart,
        "on-item-drag-end": _vm.onItemDragEnd,
        "on-item-drop": _vm.onItemDrop,
        "klass": index === _vm.model[_vm.childrenFieldName].length - 1 ? 'tree-last' : ''
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(_) {
          return [_vm._t("default", [(!_vm.model.loading) ? _c('i', {
            class: _.vm.themeIconClasses,
            attrs: {
              "role": "presentation"
            }
          }) : _vm._e(), _vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(_.model[_vm.textFieldName])
            }
          })], {
            vm: _.vm,
            model: _.model
          })]
        }
      }])
    })
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ec3b31b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-jstree/src/tree-item.vue
// module id = 13
// module chunks = 0